import {
  AuthFooterBar,
  AuthTopBar,
  EditorialPanel,
  ExplorerLoginPromo,
  SignInForm,
} from '@/features/auth/components';

/**
 * LoginPage — bare full-bleed layout (no AppLayout chrome).
 * Composes the editorial left panel + the sign-in column.
 */
export default function LoginPage() {
  return (
    <div className="vault-surface h-screen overflow-hidden flex text-ink-900">
      <EditorialPanel />

      <section className="flex-1 min-w-0 h-screen flex flex-col relative lg:border-l lg:border-white/40">
        <AuthTopBar />
        <div className="flex-1 min-h-0 overflow-y-auto px-5 sm:px-10 lg:px-14 safe-pt safe-pb">
          <div className="min-h-full flex flex-col items-center justify-center py-8 sm:py-10">
          <div className="lg:hidden w-full max-w-[440px] mb-8">
            <ExplorerLoginPromo variant="light" />
          </div>
          <SignInForm />
          </div>
        </div>
        <AuthFooterBar />
      </section>
    </div>
  );
}
